import { render, staticRenderFns } from "./BienPreview.vue?vue&type=template&id=3f4c19df&"
import script from "./BienPreview.vue?vue&type=script&lang=js&"
export * from "./BienPreview.vue?vue&type=script&lang=js&"
import style0 from "./BienPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports